export const SC_LINE_MODS_ATTRIBUTE = '_awtMods';

const EDIT_BUNDLE = 0;
const QUANTITY_EDIT = 1;
const REMOVAL = 2;
const SWAP_VARIANT = 3;

export const SC_LINE_MODS = {
  EDIT_BUNDLE,
  QUANTITY_EDIT,
  REMOVAL,
  SWAP_VARIANT,
};

export const SOURCE = {
  dynamo: 'CustomAttributes',
  shopify: 'customAttributes',
};

/**
 * Returns true if a modification is allowed on a line. By default, if a mod
 * does not exist on the property, it returns true
 *
 * @param line
 * @param mod
 * @param prop
 */
export const scLineModAllowed = (line, mod: number, prop: string): boolean => {
  const modValue = getModAttribute(line, prop);

  return (modValue[modValue.length - 1 - mod] || '0') !== '1';
};

/**
 * Takes an scLine and adds or modifies existing CustomAttributes to set a
 * specific modification to be allowed or not. Returns the same line with the
 * custom attributes updated
 *
 * @param line
 * @param mod
 * @param allowed
 * @param prop
 */
export const scLineModSet = (
  line,
  mod: number,
  allowed: boolean,
  prop: string,
) => {
  const modValue = getModAttribute(line, prop);
  const newMod = setNewModValue(modValue, mod, allowed);

  return upsertModAttributeToLine(line, newMod, prop);
};

const getModAttribute = (line, prop = 'customAttributes'): string =>
  (line[prop]?.find(({ key }) => key === SC_LINE_MODS_ATTRIBUTE) || {}).value ||
  '';

const upsertModAttributeToLine = (
  line,
  modValue: string,
  prop = 'customAttributes',
) => ({
  ...line,
  [prop]: [
    ...(line[prop]?.filter(({ key }) => key !== SC_LINE_MODS_ATTRIBUTE) || []),
    { key: SC_LINE_MODS_ATTRIBUTE, value: modValue },
  ],
});

const setNewModValue = (modValue: string, mod, allowed: boolean): string => {
  // Add as many zeroes as needed for the new mod position
  const paddedMod = modValue.padStart(mod, '0');

  // Take the first part of the existing mods, set the new value, and append
  // the last part of the existing mods
  return (
    paddedMod.slice(0, paddedMod.length - 1 - mod) +
    (allowed ? '0' : '1') +
    paddedMod.slice(paddedMod.length - mod)
  );
};
